import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlertError from '../../common/AlertError';
import Popup from '../../common/Popup';


class ClientCodeDialogView extends Component {
  render() {
    if (this.props.dialog_opened) {
      return (
        <Popup show
               clsName="clientcode-dialog"
               topBarTitle="Reminder!"
               onClose={this.props.onClose}>
          <div className="error-text">
            { this.props.popupErrors.messages }
          </div>
        </Popup>
      );
    }
    return null;
  }
}

ClientCodeDialogView.propTypes = {
  popupErrors: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ClientCodeDialogView;



// WEBPACK FOOTER //
// ./src/components/case/client_code_dialog/clientCodeDialogView.js